import _ from 'lodash'
import axios from 'axios'

import { getName } from './util'

export default ({
  type = '',
  state = {},
  query = {},
  reduxArr = [],

  listApi = '',
  detailApi = '',
  addApi = '',
  updateApi = '',
  removeApi = '',

  listFormat,
  detailFormat,
  addFormat,
  updateFormat,
  removeFormat
}) => {
  // 列表
  const action_list_success = `list_${ type }_success`
  const action_list_error = `list_${ type }_error`
  const action_list_reset = `list_${ type }_reset`
  const action_list_loading = `list_${ type }_loading`
  const action_list_loaded = `list_${ type }_loaded`
  const action_list_store_query = `list_${ type }_store_query`

  // 查
  const action_detail_success = `detail_${ type }_success`
  const action_detail_error = `detail_${ type }_error`
  const action_detail_reset = `detail_${ type }_reset`
  const action_detail_loading = `detail_${ type }_loading`
  const action_detail_loaded = `detail_${ type }_loaded`
  // 增
  const action_add_success = `add_${ type }_success`
  const action_add_error = `add_${ type }_error`
  const action_add_reset = `add_${ type }_reset`
  const action_add_loading = `add_${ type }_loading`
  const action_add_loaded = `add_${ type }_loaded`
  // 改
  const action_update_success = `update_${ type }_success`
  const action_update_error = `update_${ type }_error`
  const action_update_reset = `update_${ type }_reset`
  const action_update_loading = `update_${ type }_loading`
  const action_update_loaded = `update_${ type }_loaded`
  // 删
  const action_remove_success = `remove_${ type }_success`
  const action_remove_error = `remove_${ type }_error`
  const action_remove_reset = `remove_${ type }_reset`
  const action_remove_loading = `remove_${ type }_loading`
  const action_remove_loaded = `remove_${ type }_loaded`

  const listInitState = {
    list_loading: false,
    list_init: false,
    list_msg: '',
    // 数据
    data: [],

    // 总记录条数
    total: 0,

    query: {
      // 当前页码
      page: 1,
      // 每页显示几条数据
      page_size: 10,

      ...query
    }
  }

  const detailInitState = {
    detail_data: {},

    detail_query: {},

    detail_loading: false,
    detail_msg: ''
  }

  const addInitState = {
    add_loading: false,
    add_msg: '',
  }

  const updateInitState = {
    update_loading: false,
    update_msg: '',
  }

  const removeInitState = {
    remove_loading: false,
    remove_msg: '',
  }

  const initState = {
    ...listInitState,
    ...detailInitState,
    ...addInitState,
    ...updateInitState,
    ...removeInitState,

    ...state
  }

  if (_.isPlainObject(reduxArr)) {
    reduxArr = [reduxArr]
  }

  reduxArr = reduxArr
    // list
    .concat({
      action: action_list_success,
      result: (state, payload) => ({
        ...state,
        ...payload,

        list_msg: '',
      })
    })
    .concat({
      action: action_list_error,
      result: (state, payload) => ({
        ...state,

        list_msg: payload,
      })
    })
    .concat({
      action: action_list_reset,
      result: (state) => ({
        ...state,
        ...listInitState
      })
    })
    .concat({
      action: action_list_loading,
      result: (state) => ({
        ...state,

        list_loading: true
      })
    })
    .concat({
      action: action_list_loaded,
      result: (state) => ({
        ...state,

        list_loading: false
      })
    })
    .concat({
      action: action_list_store_query,
      result: (state, payload) => ({
        ...state,

        query: {
          ...state.query,
          ...payload
        }
      })
    })
    // detail
    .concat({
      action: action_detail_success,
      result: (state, payload) => ({
        ...state,
        ...payload,

        detail_msg: '',
      })
    })
    .concat({
      action: action_detail_error,
      result: (state, payload) => ({
        ...state,

        detail_msg: payload,
      })
    })
    .concat({
      action: action_detail_reset,
      result: (state, payload) => ({
        ...state,
        ...detailInitState
      })
    })
    .concat({
      action: action_detail_loading,
      result: (state) => ({
        ...state,

        detail_loading: true
      })
    })
    .concat({
      action: action_detail_loaded,
      result: (state) => ({
        ...state,

        detail_loading: false
      })
    })
    // add
    .concat({
      action: action_add_success,
      result: (state, payload) => {
        let data = state.data
        data.unshift({ ...payload })

        return ({
          ...state,
          data,

          add_msg: '',
        })}
    })
    .concat({
      action: action_add_error,
      result: (state, payload) => ({
        ...state,

        add_msg: payload,
      })
    })
    .concat({
      action: action_add_reset,
      result: (state) => ({
        ...state,
        ...addInitState
      })
    })
    .concat({
      action: action_add_loading,
      result: (state) => ({
        ...state,

        add_loading: true
      })
    })
    .concat({
      action: action_add_loaded,
      result: (state) => ({
        ...state,

        add_loading: false
      })
    })
    // update
    .concat({
      action: action_update_success,
      result: (state, payload) => ({
        ...state,
        data: state.data.map(v => (
          v.id === payload.id ?
            {
              ...v,
              ...payload
            } :
            { ...v }
        )),

        update_msg: '',
      })
    })
    .concat({
      action: action_update_error,
      result: (state, payload) => ({
        ...state,

        update_msg: payload,
      })
    })
    .concat({
      action: action_update_reset,
      result: (state) => ({
        ...state,
        ...updateInitState
      })
    })
    .concat({
      action: action_update_loading,
      result: (state) => ({
        ...state,

        update_loading: true
      })
    })
    .concat({
      action: action_update_loaded,
      result: (state) => ({
        ...state,

        update_loading: false
      })
    })
    // remove
    .concat({
      action: action_remove_success,
      result: (state, payload) => ({
        ...state,
        data: _.filter(state.data, v => (
          v.id !== payload.id
        )),

        remove_msg: '',
      })
    })
    .concat({
      action: action_remove_error,
      result: (state, payload) => ({
        ...state,

        remove_msg: payload,
      })
    })
    .concat({
      action: action_remove_reset,
      result: (state) => ({
        ...state,
        ...removeInitState
      })
    })
    .concat({
      action: action_remove_loading,
      result: (state) => ({
        ...state,

        remove_loading: true
      })
    })
    .concat({
      action: action_remove_loaded,
      result: (state) => ({
        ...state,

        remove_loading: false
      })
    })

  const list_success = (payload) => ({ payload, type: action_list_success })
  const list_error = (payload) => ({ payload, type: action_list_error })
  const list_reset = (payload) => ({ payload, type: action_list_reset })
  const list_loading = (payload) => ({ payload, type: action_list_loading })
  const list_loaded = (payload) => ({ payload, type: action_list_loaded })
  const list_store_query = (payload) => ({ payload, type: action_list_store_query })

  const detail_success = (payload) => ({ payload, type: action_detail_success })
  const detail_error = (payload) => ({ payload, type: action_detail_error })
  const detail_reset = (payload) => ({ payload, type: action_detail_reset })
  const detail_loading = (payload) => ({ payload, type: action_detail_loading })
  const detail_loaded = (payload) => ({ payload, type: action_detail_loaded })

  const add_success = (payload) => ({ payload, type: action_add_success })
  const add_error = (payload) => ({ payload, type: action_add_error })
  const add_reset = (payload) => ({ payload, type: action_add_reset })
  const add_loading = (payload) => ({ payload, type: action_add_loading })
  const add_loaded = (payload) => ({ payload, type: action_add_loaded })

  const update_success = (payload) => ({ payload, type: action_update_success })
  const update_error = (payload) => ({ payload, type: action_update_error })
  const update_reset = (payload) => ({ payload, type: action_update_reset })
  const update_loading = (payload) => ({ payload, type: action_update_loading })
  const update_loaded = (payload) => ({ payload, type: action_update_loaded })

  const remove_success = (payload) => ({ payload, type: action_remove_success })
  const remove_error = (payload) => ({ payload, type: action_remove_error })
  const remove_reset = (payload) => ({ payload, type: action_remove_reset })
  const remove_loading = (payload) => ({ payload, type: action_remove_loading })
  const remove_loaded = (payload) => ({ payload, type: action_remove_loaded })

  return {
    reducer: (state = initState, action) => {
      const { type, payload } = action

      for (let i = 0, len = reduxArr.length; i < len; i++) {
        if (type === reduxArr[i].action) {
          return reduxArr[i].result(state, payload)
        }
      }

      return state
    },

    list_success,
    list_error,
    list_reset,
    list_loading,
    list_loaded,
    list_store_query,

    detail_success,
    detail_error,
    detail_reset,
    detail_loading,
    detail_loaded,

    add_success,
    add_error,
    add_reset,
    add_loading,
    add_loaded,

    update_success,
    update_error,
    update_reset,
    update_loading,
    update_loaded,

    remove_success,
    remove_error,
    remove_reset,
    remove_loading,
    remove_loaded,

    // 增删改查的方法
    // 获取列表
    [getName(type, 'get', 'list')]: (params = {}, ignoreCache) => {
      return async (dispatch, getStore) => {
        const {
          [type]: {
            list_loading: loading,
            list_init,
            query,
            data
          }
        } = getStore()

        let reset = false // 是否对数据页码进行重置
        
        const assignParams = Object.assign({}, query, params)


        if (loading) {
          return ['重复请求']
        }

        const isEqual = _.isEqual(query, assignParams)
        const _query = _.omit(query, 'page')
        const _assignParams = _.omit(assignParams, 'page')
        
        if (!ignoreCache && list_init && isEqual) {
          return [null, data]
        }
  
        if (ignoreCache || !_.isEqual(_query, _assignParams)) {
          reset = true
          _.extend(assignParams, { page: 1 })
        }
        
        dispatch(list_loading())

        const [err, res] = await axios.post(listApi, assignParams)
        
        dispatch(list_loaded())

        if (listFormat instanceof Function) {
          return listFormat([err, res], dispatch)
        }

        if (err) {
          dispatch(list_error(err))

          return [err]
        }
     
        dispatch(list_success({
          list_init: true,
          data: reset ? res : [...data, ...res],
          query: assignParams
        }))

        return [null, res]
      }
    },
    // 获取数据详情
    [getName(type, 'get')]: (params = {}, ignoreCache) => {
      return async (dispatch, getStore) => {
        const {
          [type]: {
            detail_query,
            detail_data,
            detail_loading: loading,
          }
        } = getStore()

        if (loading) {
          return ['重复请求']
        }

        if (!ignoreCache && _.isEqual(detail_query, params)) {
          return [null, detail_data]
        }

        dispatch(detail_reset())

        dispatch(detail_loading())

        const [err, res] = await axios.post(detailApi, params)

        dispatch(detail_loaded())

        if (detailFormat instanceof Function) {
          return detailFormat([err, res], dispatch)
        }

        if (err) {
          dispatch(detail_error(err))

          return [err]
        }

        const { code, message, object } = res

        dispatch(detail_success({
          detail_data: {
            ...object
          },
          detail_query: params
        }))

        return [null, object]
      }
    },
    // 添加
    [getName(type, 'add')]: (params = {}, cb) => {
      return async dispatch =>  {
        dispatch(add_loading())

        const [err, res] = await axios.post(addApi, params)

        dispatch(add_loaded())

        if (addFormat instanceof Function) {
          return addFormat([err, res], dispatch)
        }

        if (err) {
          dispatch(add_error(err))

          return [err]
        }

        const { code, message, object } = res

        dispatch(add_success(object))

        cb && cb()

        return [null, object]
      }
    },
    // 修改
    [getName(type, 'update')]: (params = {}) => {
      return async (dispatch, getStore) => {
        const {
          [type]: {
            update_loading: loading
          }
        } = getStore()

        if (loading) {
          return ['重复请求']
        }

        dispatch(update_loading())

        const [err, res] = await axios.post(updateApi, params)

        dispatch(update_loaded())

        if (updateFormat instanceof Function) {
          return updateFormat([err, res], dispatch)
        }

        if (err) {
          dispatch(update_error(err))

          return [err]
        }

        const { code, message, object } = res

        dispatch(update_success(object))

        return [null, object]
      }
    },
    // 删除
    [getName(type, 'remove')]: (params = {}) => {
      return async dispatch => {
        dispatch(remove_loading())

        const [err, res] = await axios.post(removeApi, params)

        dispatch(remove_loaded())

        if (removeFormat instanceof Function) {
          return removeFormat([err, res], dispatch)
        }

        if (err) {
          dispatch(remove_error(err))

          return [err]
        }

        const { code, message, object } = res

        dispatch(remove_success(params))

        return [null, object]
      }
    },
    [getName(type, 'store', 'query')]: (params = {}) => {
      return async dispatch => {
        dispatch(list_store_query(params))
      }
    }
  }
}
